import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.2 18.672c-.5-.294-1.1-.098-1.4.39-.3.49-.9.587-1.4.392a.77.77 0 0 1-.4-.391c-.3-.49-.9-.587-1.4-.391-.5.293-.6.88-.4 1.368.3.489.6.782 1.1 1.076.5.293 1 .39 1.5.39 1 0 2-.488 2.6-1.466.5-.489.3-1.075-.2-1.368m7.8-4.009c-1.1 0-2-.88-2-1.956V7.82C19 3.52 15.4 0 11 0S3 3.52 3 7.82v4.888c0 1.076-.9 1.956-2 1.956-.6 0-1 .39-1 .977s.4.978 1 .978h20c.6 0 1-.391 1-.978s-.4-.977-1-.977zm-16.5 0c.3-.587.5-1.271.5-1.956V7.82c0-3.226 2.7-5.865 6-5.865s6 2.64 6 5.865v4.888c0 .685.2 1.369.5 1.956z"
    }, null, -1)
  ]))]))
}
export default { render: render }